import React from 'react';
import PropTypes from 'prop-types';
import TopNavBar from "../TopNavBar/TopNavBar";
import classes from "../MobileAppPreview.module.scss";

export default function SignInUpScreen({ background, logo, logoWidth , logoHeight, fontFamily, primaryColorMobile }) {
    return (
    <div className={classes.signInScreenWrapper}>
      <div className={classes.dynamicIsland} />
      <TopNavBar isSplashAndSignInUpPage />

      {background ? (
        <img src={background} alt="bg" className={classes.signInBackground} />
      ) : null}

      <div className={classes.signInContent}>
        {logo ? (
          <img
            src={logo}
            alt="logo"
            className={classes.signInLogo}
            style={{ 
              width: logoWidth ? `${logoWidth}px` : 'auto',
              height: logoHeight ? `${logoHeight}px` : 'auto',
              aspectRatio: logoWidth && logoHeight ? `${logoWidth}/${logoHeight}` : 'auto'
            }}
          />
        ) : null}

        <h2 className={`${classes.heading} ${fontFamily}`}>Sign in</h2>

        <label className={fontFamily}>Email</label>
        <input type="email" placeholder="Enter your email" className={fontFamily} disabled />

        <label className={fontFamily}>Password
          <span
            className={`${classes.forgotLink} ${fontFamily}`}
            style={{ color: primaryColorMobile }}>
              Forgot password
          </span>
        </label>
        <input type="password" placeholder="Enter your password" className={fontFamily} disabled />

        <button className={`${classes.signInBtn} ${fontFamily}`}>
            Sign in
        </button>

        <p className={`${classes.signupPrompt} ${fontFamily}`}>
          Are you new to OptimallyMe?
          <span
            className={`${classes.createLink} ${fontFamily}`}
            style={{ color: primaryColorMobile }}>
              Create account
          </span>
        </p>

        <p className={`${classes.disclaimer} ${fontFamily}`}>
          By using this service, you agree to our
          <span
            className={`${classes.link} ${fontFamily}`}
            style={{ color: primaryColorMobile }}>
              Terms of Use
          </span>
          and
          <span
            className={`${classes.link} ${fontFamily}`}
            style={{ color: primaryColorMobile }}>
              Privacy Policy
          </span>
        </p>
      </div>
    </div>
);
}

SignInUpScreen.propTypes = {
    background: PropTypes.string,
    logo: PropTypes.string,
    logoWidth: PropTypes.number,
    logoHeight: PropTypes.number,
    fontFamily: PropTypes.string,
    primaryColorMobile: PropTypes.string,
};